import { useState } from "react";
import { useTranslation } from "next-i18next";
import debounce from "lodash/debounce";
import { switchUserApi, getSession } from "@/api/user";
import { setUserInfoCookie } from "@/utils/cookie";
import { Spin } from "antd";
import { useRouter } from "next/router";
import Icon from "@/components/Icon";
import { useAppDispatch } from "@/store/hooks";
import { setUserInfo } from "@/store/user";
import { onKeyActivate } from "@/utils/index";

/**
 * 切换IB
 * @returns
 */
const SwitchIb = ({ utype, refreshUserInfo }: { utype: string; refreshUserInfo: () => void }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);
  const router = useRouter();
  const dispatch = useAppDispatch();

  const switchUser = async () => {
    setLoading(true);
    try {
      await switchUserApi();
      const userInfo: any = await getSession();
      setUserInfoCookie(userInfo);
      dispatch(setUserInfo(userInfo));
      setLoading(false);
      refreshUserInfo();
      // 这里修改成和切换账号一样的逻辑，回去首页，因为还要调用site-info接口，看是否需要根据所在商城进行跳转
      router.replace("/");
    } catch (errorInfo) {
      console.log("Failed:", errorInfo);
      setLoading(false);
    }
  };

  return (
    <Spin spinning={loading}>
      <div
        className="item-center flex h-[45px] cursor-pointer justify-between text-sm font-semibold text-stone-900 transition-colors hover:text-primary lg:ml-8 lg:h-auto lg:justify-start lg:font-medium lg:text-stone-800"
        onClick={debounce(switchUser, 500)}
        role="button"
        tabIndex={0}
        onKeyDown={onKeyActivate(() => switchUser())}
      >
        <Icon name="ib" size={20} className="mr-1 hidden lg:block" title="icon ib" />
        <div className="flex items-center">{utype === "client" ? t("menu.switch_ib") : t("menu.switch_client")}</div>
        <Icon name="arrow-right-gray" isMobile size={16} className="block lg:hidden" title="icon arrow-right-gray" />
      </div>
    </Spin>
  );
};

export default SwitchIb;
